import { router, usePage } from "@inertiajs/react";
import {
  unstable_createAdapterProvider as createAdapterProvider,
  renderQueryString,
  type unstable_AdapterInterface as AdapterInterface,
  type unstable_AdapterOptions as AdapterOptions,
  type unstable_UpdateUrlFunction as UpdateUrlFunction,
} from "nuqs/adapters/custom";
import * as React from "react";
import { useEffect } from "react";

function searchParamsForUrl(currentUrl: string) {
  const baseUrl = typeof window === "undefined" ? "http://localhost" : window.location.origin;

  return new URL(currentUrl, baseUrl).searchParams;
}

function useNuqsInertiaAdapter(): AdapterInterface {
  const currentUrl = usePage().url;
  const [searchParams, setSearchParams] = React.useState(() => searchParamsForUrl(currentUrl));

  useEffect(() => {
    setSearchParams(searchParamsForUrl(currentUrl));
  }, [currentUrl]);

  const updateUrl: UpdateUrlFunction = React.useCallback(
    (search: URLSearchParams, options: AdapterOptions) => {
      const url = new URL(window.location.href);
      url.search = renderQueryString(search);
      setSearchParams(url.searchParams);

      if (options?.shallow === false) {
        router.visit(url, {
          replace: options.history === "replace",
          preserveScroll: !options.scroll,
          preserveState: true,
          async: true,
        });
        return;
      }

      const method = options.history === "replace" ? "replace" : "push";

      router[method]({
        url: url.toString(),
        clearHistory: false,
        encryptHistory: false,
        preserveScroll: !options.scroll,
        preserveState: true,
      });
    },
    [],
  );

  return {
    searchParams,
    updateUrl,
  };
}

export const NuqsAdapter: React.FC<{ children: React.ReactNode }> =
  createAdapterProvider(useNuqsInertiaAdapter);
